import ContinueShopping from './lib/ContinueShopping.js';

export default ContinueShopping;